import React from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
const ListingContainer = ({
  title,
  location,
  status,
  pending,
  onApprove,
  onDecline,
  onremove,
  onView,
  approve,
  analytics
}) => {
  return (
    <Card>
      <Card.Body>
        <Row className="align-items-center">
          <Col sm={9}>
            <Card.Title>Business Title: {title}</Card.Title>
            <Card.Text>Location: {location}</Card.Text>
            <Card.Text>Status: {status}</Card.Text>
           {approve && <Card.Text>Analytics: {analytics}</Card.Text>}
          </Col>
          <Col sm={3}>
            <div className="d-flex justify-content-end">
              {pending ? (
                <Button variant="danger" onClick={onDecline} className="mr-2">
                  Decline
                </Button>
              ) : (
                <Button variant="danger" onClick={onremove} className="mr-2">
                  Remove
                </Button>
              )}

              {pending && (
                <Button variant="success" onClick={onApprove} className="mr-2">
                  Accept
                </Button>
              )}

              <Button variant="warning" onClick={onView} className="mr-2">
                View
              </Button>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default ListingContainer;
